import 'react-calendar/dist/Calendar.css'; 
import '../styles/ReservaInterna.css';

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAlert } from '../context/AlertContext';
import Calendar from 'react-calendar';

import useDisponibilidad from '../hooks/useDisponibilidad';
import useDropdownData from '../hooks/useDropdownData';
import useObtenerCitaPorFecha from '../hooks/useObtenerCitaPorFecha';
import useGuardarCitaInterna from '../hooks/useGuardarCitaInterna';
import DocumentViewer from './DocumentViewer';

import { construirFechaSinHoraExtra, combinarFechaYHora, urlApi } from '../helpers/functionHelpers';
import { motion } from 'framer-motion';

const ReservaInterna = () => {
  const navigate = useNavigate();
  const duraciones = [
    '15 minutos', 
    '30 minutos', 
    '45 minutos', 
    '1 hora', 
    '1.5 horas', 
    '2 horas', 
    '2.5 horas', 
    '3 horas', 
    '4 horas'
  ];
  const [dataCitaInterna, setDataCitaInterna] = useState({
    fechaRsv: '',
    dataIni: '',
    dataFin: '',
    numeroPersonas: '',
    motivo: '',
    vehiculo_id: '',
    AlmacenAsignado_id: '',
  });
  const [almacen, setAlmacen] = useState({
    id:'',
    ubicacion: '', 
    descripcion: ''
  });
  
  const [duracion, setDuracion] = useState('');
  const [horarioSeleccionado, setHorarioSeleccionado] = useState('');
  const [horariosOcupados, setHorariosOcupados] = useState([]);


  const { disponibilidad, generarDisponibilidad } = useDisponibilidad(duracion, horariosOcupados);
  const { data: ubicacions, loading: loadingUbicacions, error: errorUbicacions } = useDropdownData(`${urlApi}/api/ubicacions`, setAlmacen, almacen.id, true);
  const { data: vehiculos, loading: loadingVehiculos, error: errorVehiculos } = useDropdownData(`${urlApi}/api/vehiculos`, setDataCitaInterna, 'containers_id', true);
  const { guardarCitaInterna, error: errorGuardarCitaInterna, success: successGuardarCitaInterna, loading: loadingGuardarCitaInterna } = useGuardarCitaInterna();
  const { citas, loading: loadingCitas, error: errorCitas } = useObtenerCitaPorFecha(dataCitaInterna.AlmacenAsignado_id, construirFechaSinHoraExtra(dataCitaInterna.fechaRsv));
  const { mostrarAlerta } = useAlert();

  useEffect(() => {
    if (dataCitaInterna.AlmacenAsignado_id && dataCitaInterna.fechaRsv){
      const horarios = citas.map((cita) => ({
        inicio: new Date(cita.dataIni).toISOString(),
        fin: new Date(cita.dataFin).toISOString(),
      }));
      setHorariosOcupados(horarios);
    };
  },[dataCitaInterna.AlmacenAsignado_id, dataCitaInterna.fechaRsv, citas]);

  const handleChange = (e) => {
    setDataCitaInterna({
      ...dataCitaInterna,
      [e.target.name]: e.target.value,
    });
  };

  const handleDateChange = (date) => {
    setDataCitaInterna((prevData) => ({
      ...prevData,
      fechaRsv: date,
    }));
  };

  const handleDuracionChange = (e) => {
    const selectedDuration = e.target.value;
    setDuracion(selectedDuration);
    generarDisponibilidad(selectedDuration);
  };

  const handleAlmacenChange = (e) => {
    setAlmacen(e.target.value);
    setDataCitaInterna((prevData) => ({
      ...prevData,
      AlmacenAsignado_id: e.target.value
    }));
  };

  const handleCrearReservacion = async () => {
    const {
      fechaRsv,
      dataIni,
      dataFin,
      numeroPersonas,
      motivo,
      unidad_id,
      AlmacenAsignado_id,
    } = dataCitaInterna;
    if (fechaRsv){
      const fechaSinFormato = construirFechaSinHoraExtra(fechaRsv);
      const fechaIn = combinarFechaYHora(fechaRsv,dataIni);
      const fechaFin = combinarFechaYHora(fechaRsv,dataFin);
      const respuesta = await guardarCitaInterna(fechaSinFormato, fechaIn, fechaFin, numeroPersonas, motivo, unidad_id, AlmacenAsignado_id);
      if (respuesta) {
        mostrarAlerta('Cita creada con éxito', 'success');
        setTimeout(() => {
          navigate(`/admin/`);
        }, 2000);
      }
    } else{
      mostrarAlerta('Ingresa una fecha', 'error');
    }
  };

  const handleHorarioSeleccionado = (slot) => {
    const [horaInicio, horaFin] = slot.split(' - '); 
    setDataCitaInterna((prevData) => ({
      ...prevData,
      dataIni: horaInicio,
      dataFin: horaFin,
      comentariosAdAlmcn: 'a',
      comentariosAdCrr: 'a'
    }));
    setHorarioSeleccionado(slot);
  };

  return (
    <div className="reserva-interna-container">
      <h2>Reserva interna</h2>
      <div className="reserva-interna-form">
      <Calendar onChange={handleDateChange} value={dataCitaInterna.fechaRsv} />
        <div className="form-fields">
          <label for="numeroPersonas">Número de personas:</label>
          <input id="numeroPersonas" name="numeroPersonas" onChange={handleChange} value={dataCitaInterna.numeroPersonas} type="number" placeholder="Cantidad" />

          <label for="motivo">Motivo:</label>
          <textarea id="motivo" name="motivo" onChange={handleChange} value={dataCitaInterna.motivo} placeholder="Introduzca el motivo"></textarea>

          <div className="form-group">
            <label for="AlmacenAsignado_id">Almacen:</label>
              {loadingUbicacions ? (
                <p>Cargando ubicaciones...</p>
              ) : errorUbicacions ? (
                <p>Error: {errorUbicacions}</p>
              ) : (
                <select id="AlmacenAsignado_id" name="AlmacenAsignado_id" value={almacen.id} onChange={handleAlmacenChange}>
                  <option value='Seleccione'>Seleccione</option>
                  {ubicacions.map((ubicacion) => (
                    <option key={ubicacion.id} value={ubicacion.id}>{ubicacion.descripcion} {ubicacion.nombreEmpresa ? `(${ubicacion.nombreEmpresa})` : ''}</option>
                  ))}
                </select>
              )}
          </div>

          <div className="form-group">
          <label htmlFor="vehiculo_id">Tipo de vehiculo:</label>
          {loadingVehiculos ? (
            <p>Cargando vehiculos...</p>
          ) : errorVehiculos ? (
            <p>Error: {errorVehiculos}</p>
          ) : (
            <select name="unidad_id" value={dataCitaInterna.unidad_id || ''} onChange={handleChange}>
              <option value="">-- Seleccione Vehículo --</option>
              {vehiculos.map((vehiculo) => (
                <option key={vehiculo.id} value={vehiculo.id}>{vehiculo.vehiculo}</option>
              ))}
            </select>
          )}
        </div>
        <div className="form-group">
          <div className="form-group">
            <label for="duracion">Duración:</label>
            <select id="duracion" name="duracion" value={duracion} onChange={handleDuracionChange}>
              <option value='Seleccione'>Seleccione</option>
              {duraciones.map((duracion, index) => (
                <option key={index} value={duracion}>
                  {duracion}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label for="disponibilidad">Disponibilidad:</label>
            <div className="horarios-disponibles" id="disponibilidad">
              {loadingCitas ? (
                <p>Cargando horarios...</p>
              ) : errorCitas ? (
                <p>Error al cargar horarios: {errorCitas}</p>
              ) : disponibilidad.length > 0 ? (
                disponibilidad.map((slot, index) => (
                  <motion.button
                    key={index}
                    className={`horario-slot ${
                      horariosOcupados.some(
                        (horario) =>
                          new Date(slot.inicio) >= new Date(horario.inicio) &&
                          new Date(slot.fin) <= new Date(horario.fin)
                      )
                        ? 'ocupado'
                        : horarioSeleccionado === slot
                        ? 'seleccionado'
                        : ''
                    }`}
                    onClick={() => handleHorarioSeleccionado(slot)}
                    whileTap={{ scale: 0.95 }}
                    transition={{ type: 'spring', stiffness: 500, damping: 20 }}
                  >
                    {slot}
                  </motion.button>
                ))
              ) : (
                <p>No hay horarios disponibles para la selección actual.</p>
              )}
            </div>
          </div>
          <motion.button 
          onClick={handleCrearReservacion} 
          className="crear-reserva-button"
          disabled={loadingGuardarCitaInterna} 
          whileTap={{ scale: 0.95 }}
          transition={{ type: 'spring', stiffness: 500, damping: 20 }}>
            {loadingGuardarCitaInterna ? 'Guardando...' : 'Guardar Cita'}
          </motion.button>
          
          {successGuardarCitaInterna && <p>Cita guardada con éxito</p>}
          {errorGuardarCitaInterna && <p style={{ color: 'red' }}>{errorGuardarCitaInterna}</p>}
        </div>
        </div>
      </div>
    </div>
  );
};

export default ReservaInterna;
